import { useQuery } from "@tanstack/react-query";

import { useBankruptcyChecklistApi } from "../../api/ClientFileApiContext";
import { ClientFileQueryKey } from "../../query/clientFileQueryKeys";

export function useBankruptcyChecklist(clientId: string | undefined) {
  const bankruptcyChecklistApi = useBankruptcyChecklistApi();

  return useQuery({
    queryKey: [ClientFileQueryKey.BankruptcyChecklist, clientId],
    queryFn: () => {
      if (!clientId) {
        throw new Error("Client ID is required");
      }
      return bankruptcyChecklistApi.getBankruptcyChecklist({ clientId });
    },
    enabled: !!clientId,
  });
}
